// extracted by mini-css-extract-plugin
export var news = "news-list-module--news--f54c4";
export var newsList = "news-list-module--newsList--54d8e";